module.exports = __webpack_public_path__ + "static/media/home-selected.cc1f3dca.svg";